import { ref } from "vue";

export class ClassRoomContext{
  public blockXml = ref("")
  public contentsUrl = ref("")
}

export const classRoomContext = new ClassRoomContext();